export default __webpack_public_path__ + "static/media/chunk_of_aerosiderite.40cd9997.png";